import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  

return(
    <div>
     
      <Sides/>
       <Helmet>
 
 <title>else if in c++ tutorial For Beginners</title>
 <meta name="description" content="else if in c++ tutorial for beginners.when if condition is true so on that time target of the will be executed. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,else if in c++ tutorial for beginners,programming language tutorial for begineers,if else statement c++,if else,if,else if,c++ programming tutorial for beginners,learn code in free online,cpp if else statement,cpp if else program,c++ if else example,c++ if else shorthand,cpp program with if else,c++ programming if else exercises,nested if else statement in cpp,c++ programming if else example pdf,c++ programming nested if else exercises,c++ programming if else questions,c programming if else example,cpp program using if else,c++ language if else programs" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-if-else" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">else if Statement in c++ </h1>
   
    <div className="first">
        <a href="/cpp-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>


<h2 className='headings'>The syntax for if-else in C++:</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">condition </span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-8">Statement;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-4">else</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-8">Statement;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<p className="mt-4 para"> If this condition is true so on that time target will be executed, but if a condition is false so if it exists and the mark of the else will execute</p>




<h3 className='heading'>Q-Write a program to input a number and check this value is greater than 1000 or not?</h3>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-8">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-8">int </span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            
            
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> Enter a no</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-2">cin </span>
            <span className="qwerty-3">&gt;&#62;</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-10"> 1000</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-10"> a </span>
            <span className="qwerty-5">is greater than</span>
            <span className="qwerty-10"> 1000</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-5"> is less than </span>
            <span className="qwerty-10">1000 </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">enter a no</span>
              <span className="qwerty-10"> 542</span>
              {"\n"}
              {"\n"}{" "}
              <span className="qwerty-10">a </span>
              <span className="qwerty-5">is less than</span>
              <span className="qwerty-4"> 1000</span>
              {"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a program to check a no is even or odd?</Card.Header>
  <Card.Body>
  
    <Card.Text>

#include &#60;iostream&#62;<br/>
using namespace std;<br/><br/>
int main ( )<br/>
&#123;<br/>
int a;<br/>
cout&#60;&#60;"Enter a no";<br/>
cin&#62;&#62;a;<br/>
if(a%2==0)<br/>
&#123;<br/>
cout&#60;&#60;"a is even";<br/>
&#125;<br/>
else<br/>
&#123;<br/>
cout&#60;&#60;"a is odd";<br/>
&#125;<br/>
return 0;<br/>
&#125;<br/>

    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>enter a value 46<br/>
a is even</Card.Footer>
</Card>


 
<h2 className='headings'>Q-Write a program to check a no of vowels by using characters?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">char </span>
            <span className="qwerty-11">cha</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            
            
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> Enter a Character</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-2">cin </span>
            <span className="qwerty-3">&gt;&#62;</span>
            <span className="qwerty-11"> cha</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-2">if</span>
            <span className="qwerty-3"> (</span>
              <span className="qwerty-11">cha </span>
            <span className="qwerty-3">=='</span>
            <span className="qwerty-10">a</span>
            <span className="qwerty-3">'||</span>
            <span className="qwerty-11">cha </span>
            <span className="qwerty-3">=='</span>
            <span className="qwerty-10">e</span>
            <span className="qwerty-3">'||</span>
            <span className="qwerty-11">cha </span>
            <span className="qwerty-3">=='</span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">'||</span>
            <span className="qwerty-11">cha </span>
            <span className="qwerty-3">=='</span>
            <span className="qwerty-10">o</span>
            <span className="qwerty-3">'||</span>
            <span className="qwerty-11">cha </span>
            <span className="qwerty-3">=='</span>
            <span className="qwerty-10">u</span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-10"> use</span>
            <span className="qwerty-5"> vowels </span>
            <span className="qwerty-10">in this</span>
            <span className="qwerty-5"> character</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-10"> no use of </span>
            <span className="qwerty-5"> vowels </span>
            <span className="qwerty-10"> in this </span>
            <span className="qwerty-5">character </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}{"\n"}
              <span className="qwerty-10">Enter a</span>
              <span className="qwerty-5">character </span>
              <span className="qwerty-10">i</span>
              {"\n"}
              {"\n"}{" "}
              <span className="qwerty-10">use</span>
              <span className="qwerty-5"> vowels</span>
              <span className="qwerty-10"> in this </span>
              <span className="qwerty-5">character</span>
            
            
              {"\n"}{"        "}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>






<h2 className='headings'>Q-Write a program to find out which no is greater between two numbers?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-9">int</span>
            <span className="qwerty-10"> a,b </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> enter 1 no</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cin </span>
            <span className="qwerty-3">&gt;&#62;</span>
            <span className="qwerty-10"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> enter 2 no</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cin </span>
            <span className="qwerty-3">&gt;&#62;</span>
            <span className="qwerty-10"> b</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">a </span>
            <span className="qwerty-3">&#62; </span>
            <span className="qwerty-10">b</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">Greater</span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-5"> a</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">Greater</span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-5"> b</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}{"\n"}
              <span className="qwerty-10">enter</span>
              <span className="qwerty-5"> 1</span>
              <span className="qwerty-10"> no</span>
              <span className="qwerty-5"> 24</span>
              {"\n"}{"\n"}
              <span className="qwerty-10">enter</span>
              <span className="qwerty-5"> 2</span>
              <span className="qwerty-10"> no</span>
              <span className="qwerty-5"> 12</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-10">Greater</span>
              <span className="qwerty-3"> = </span>
              <span className="qwerty-5">24</span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>

<h2 className="mt-4 mh2">Nested if statement in c++</h2>
<p className="mt-3 para">If we write an entire if-else construct within either the body of the if statement or an else statement. That is known as nesting if the list or nested if statement in c++ and learn <a href="https://www.codeexampler.com/cpp-break">C++ Break Statement</a><br/>
Nested list in C++<br/>
</p>


<h2 className='headings'>Q-Write a program to input a no and check nested list?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10"> i;</span>
           
            {"\n"}{"\n"}
            
            
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> enter a no \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-2">cin </span>
            <span className="qwerty-3">&gt;&#62;</span>
            <span className="qwerty-10"> i</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}{" "}
      
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> 100</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{" "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> no is less than</span>
            <span className="qwerty-10"> 100</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">&#62;</span>
            <span className="qwerty-3">=</span>
            <span className="qwerty-10"> 1000</span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> greater than </span>
            <span className="qwerty-10"> 1000</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}{"    "}
            <span className="qwerty-7">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5"> Between </span>
            <span className="qwerty-10">100</span>
            <span className="qwerty-5"> to </span>
            <span className="qwerty-10">1000 </span>
            <span className="qwerty-3">";</span>
            {"\n"}{"\n"}{"     "}
            <span className="qwerty-3">&#125; </span>
          
            {"\n"}{"\n"}{"  "}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}{"\n"}{"   "}
            
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}{"   "}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}{"\n"}
              <span className="qwerty-10">enter</span>
              <span className="qwerty-5"> a no</span>
              <span className="qwerty-10"> 580</span>
              {"\n"}
              {"\n"}{" "}
              <span className="qwerty-5">Between</span>
              <span className="qwerty-10"> 100 </span>
              <span className="qwerty-5">to</span>
              <span className="qwerty-10"> 1000</span>
            
              {"\n"}{"  "}
              </code>{"\n"}{"   "}</pre>
        </div>
      </div>





      <h2 className='headings'>Q-Write a program to check gender inside a nested list in C++?</h2>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%',paddingLeft:'2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-9">char </span>
            <span className="qwerty-10"> sex;</span>
           
            {"\n"}{"\n"}
            
            
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> enter the gender</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cin </span>
            <span className="qwerty-3">&gt;&#62;</span>
            <span className="qwerty-10"> sex</span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
      
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">sex </span>
            <span className="qwerty-3">== </span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-10">m</span>
            <span className="qwerty-3">')</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> this is</span>
            <span className="qwerty-10"> male</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">if</span>
            <span className="qwerty-3"> (</span>
            <span className="qwerty-10">sex </span>
            <span className="qwerty-3">== </span>
            <span className="qwerty-3">'</span>
            <span className="qwerty-10">f</span>
            <span className="qwerty-3">')</span>
            {"\n"}{"\n"}
            <span className="qwerty-3"> &#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-3"> "</span>
            <span className="qwerty-5"> this is</span>
            <span className="qwerty-10"> female</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-10">else</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-9">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-3">"</span>
            <span className="qwerty-5">not </span>
            <span className="qwerty-10">male</span>
            <span className="qwerty-5"> and not </span>
            <span className="qwerty-10">female</span>
            <span className="qwerty-3">";</span>
            {"\n"}
            <span className="qwerty-5">return </span>
            <span className="qwerty-10">0; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">enter the gender</span>
            
              <span className="qwerty-4"> f</span>
              {"\n"}
              {"\n"}
              <span className="qwerty-10">this is</span>
              <span className="qwerty-5"> female </span>
              {"\n"}
              {"\n"}</code></pre>
        </div>
      </div>

<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/cpp-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cifelse;